<template>
  <div class="logout">
    <h1>Logout</h1>
    <div v-if="loading">
      Logging you out...
    </div>
    <div v-else>
      <div v-if="error">
        There was an error logging you out: {{error.message}}
      </div>
      <div v-else>
        <div>You successfully logged out</div>
        <div><a href="/">Home</a></div>
        <div><a href="/login">Log back in</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      loading: false,
      error: null,
    }
  },
  mounted() {
    this.loading = true
    axios.post('/auth/logout').then(() => {
      this.$router.history.push('/')
    }).catch(error => {
      this.error = error
    }).then(() => {
      this.loading = false
    })
  }
}
</script>

<style>

</style>
